import { Icon } from "@utp/react-components-prod";
import useRoleActive from "hooks/useRoleActive";
import { URL_OFFICE_ADMISSION } from "utils/ConstantsAndNum";

export const Contact = () => {
  const { isRoleEPG } = useRoleActive();

  const handleContactTextPREG = () => {
    return (
      <span>
        Contáctate con tu asesor educativo o envía tu solicitud a la{" "}
        <a
          href={URL_OFFICE_ADMISSION}
          target="_blank"
          rel="noopener noreferrer"
          className="text-color-primary font-bold items-center  underline mx-2 inline relative"
        >
          {" "}
          Oficina de Admisión{" "}
          <Icon iconName="external-link" size={18} className="ml-2 absolute" />
        </a>{" "}
        <span className="ml-9">
          e incluye la información y evidencia relevante.
        </span>
      </span>
    );
  };
  

  const handleContactTextEPG = () => {
    return (
      <span>
        Contáctate con tu asesor educativo o envía un mensaje a{" "}
        <a
          href={`mailto:admisionepg@utp.edu.pe`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-color-primary font-bold items-center  underline inline relative"
        >
          {" "}
          admisionepg@utp.edu.pe
        </a>{" "}
        <span>
          e incluye la información y evidencia relevante.
        </span>
      </span>
    );
  };

  return (
    <p className="text-color-01 flex" data-testid="contact-text">
      {isRoleEPG
        ? handleContactTextEPG()
        : handleContactTextPREG()}
    </p>
  );
};
